import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { UserStore } from 'app/core/services/user.store';
import { of } from 'rxjs';

export const IsAdminGuard: CanActivateFn | CanActivateChildFn = () => {
  const router: Router = inject(Router);
  const userStore = inject(UserStore);
  if (userStore.isAdmin()) {
    return of(true);
  } else {
    router.navigate(['/dashboard']);
    return of(false);
  }
};
